export default class MarcheLigneInfosDto {
  marcheId;
  ligneId;
  ponderation;

  constructor(marcheId) {
    this.marcheId = marcheId;
  }
}